import AuthGuard from "./auth_guard";
import NotPaidGuard from "@/router/not_paid_guard";

export default [
    {
        path: '/other',
        name: 'other',
        component: () => import('../views/Other/Other'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.other', customName: null, disabled: true, to: {} },
        ]
    },

    {
        path: '/other/telegram-bot',
        name: 'telegram_bot',
        component: () => import('../views/Other/TelegramBot/TelegramBot'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.other', customName: null, disabled: false, to: {name: 'other'} },
            { name: 'msg.telegramBot', customName: null, disabled: true, to: {} },
        ]
    },

    {
        path: '/other/markers',
        name: 'markers',
        component: () => import('../views/Other/Markers/Markers'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.other', customName: null, disabled: false, to: {name: 'other'} },
            { name: 'msg.markers', customName: null, disabled: true, to: {} },
        ]
    },

    {
        path: '/other/profile',
        name: 'profile',
        component: () => import('../views/Other/Profile/Profile.vue'),
        beforeEnter: NotPaidGuard,
        breadcrumbs: [
            { name: 'msg.other', customName: null, disabled: false, to: {name: 'other'} },
            { name: 'msg.profile', customName: null, disabled: true, to: {} },
        ]
    },

    {
        path: '/other/curator',
        name: 'curator',
        component: () => import('../views/Other/Curator/Curator'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.other', customName: null, disabled: false, to: {name: 'other'} },
            { name: 'msg.curator', customName: null, disabled: true, to: {} }
        ]
    }
]